<template>
  <div class="loading-view">
    <img alt="Cinch Budget logo" class="logo" :src="logo" />
    <div class="loading-text">
      {{ isLoading ? 'Loading...' : 'Redirecting to login...' }}
    </div>
  </div>
</template>

<script setup>
import { useAuth0 } from '@auth0/auth0-vue'
import logo from '@/assets/logo.svg'

const { isLoading } = useAuth0()
</script>

<style scoped>
.loading-view {
  text-align: center;
  padding: 3rem 2rem;
}

.logo {
  display: block;
  margin: 0 auto 2rem auto;
  max-width: 200px;
  height: auto;
}

.loading-text {
  color: var(--color-text);
  font-size: 1.1rem;
}
</style>